<template>
    <div class="page-wrap">
        <div class="session-form-hold">
            <base-card>
                <v-card-text class="text-center">
                    <!-- <v-avatar size="60" class="mb-4">
                        
                    </v-avatar> -->
                    <img src="@/assets/images/adpoints-logo.png" alt="" />*
                    <h5>{{ header_message }}</h5>
                    <h6 class="text--disabled font-weight-medium">
                        {{ subheader_message }}
                    </h6>
                    <v-progress-circular
                        v-if="!loading"
                        :size="40"
                        :width="7"
                        color="purple"
                        indeterminate
                    ></v-progress-circular>                    
                    <v-btn class="m-4 mt-4" 
                            v-if="success"
                            block 
                            color="primary"                             
                            dark                            
                            to="/auth/login"
                        >Proceed To Login</v-btn>

                    <!-- <v-checkbox
                        v-model="checkbox1"
                        label="I have read and agree to the terms of service."
                    ></v-checkbox> -->                    
                </v-card-text>
            </base-card>
        </div>
    </div>
</template>
<script>
import api from "src/api/index";

export default {
    name: 'ActivateAccount',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Activate Account'
    },
    data() {
        return {
            header_message: 'Activating...',
            subheader_message: 'Please wait',
            loading: false,         
            success: false,
            code: ''   
        }
    },
    methods: {
        triggerActivation() {    
            var self = this;            
            api.auth.activateUser(self.code)
            .then((rsp)=>{                
                self.header_message = "Activation Completed";
                self.subheader_message = 'You can now login into your account!';
                self.success = true;
            })
            .catch((error)=>{
                self.header_message = "Hmm... That's weird..."
                self.subheader_message = error.response.data.message || "There has been an error while activating you account.";                
            })
            .finally(()=>{
                self.loading = true;
            })
        }
    },
    created() {
        this.code = this.$route.params.code;
    },
    mounted() {
        this.triggerActivation();
    }
}
</script>
<style lang="scss" scoped>
.page-wrap {
    background-color: #f2f4f4 !important;
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
</style>
